'use strict';

module.exports = {
    PROMOTION_LOCKED_FOR_DELETION: 423,
};
